export const videoUrl = 'http://localhost:3333/lessons/video/';
